import { user } from '@debbie/common/dist/performed-by/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { DocumentFoundationIcon, DocumentSignedIcon, DocumentTypeBadge, DocumentVisibilityIcon, } from '../documents/DocumentIndicators.js';
import File from '../File/index.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import HistItem from './HistItem.js';
const DocumentItem = ({ date, data }) => {
    const lang = useSelector((s) => s.lang);
    const file = data.signedFile ?? data.file;
    return (React.createElement(HistItem, { date: date, heading: React.createElement("div", null,
            data.createdByUserId && (React.createElement("span", { style: { marginRight: '0.5em' } },
                React.createElement(PerformedBy, { performedBy: user(data.createdByUserId) }))),
            lang.history.documentAdded,
            React.createElement(DocumentIndicators, null,
                React.createElement(DocumentTypeBadge, { document: data }),
                React.createElement(DocumentSignedIcon, { document: data }),
                React.createElement(DocumentFoundationIcon, { document: data }),
                React.createElement(DocumentVisibilityIcon, { document: data }))) }, file && React.createElement(File, { file: file })));
};
export default DocumentItem;
const DocumentIndicators = styled.span `
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 12px;
  gap: 8px;

  > span {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=DocumentItem.js.map